import { Avatar } from '@mui/material'
import { TableHeaderConfigWithType } from '../../components/_EOS/Table'
import { Product, ProductImage } from './entities/Product'
import React from 'react'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { YesNoBadge } from '../../components/YesNoBadge'

export const generateTableHeadersProduct = (
  productOrigins: ProductOrigin[] | undefined
) => {
  const tableHeadersProduct: TableHeaderConfigWithType<Product>[] = [
    {
      field: 'image',
      title: 'Imagen',
      sortable: false,
      formater: (image: unknown) => setImage(image as unknown)
    },
    {
      field: 'sku',
      title: 'SKU',
      sortable: false
    },
    {
      field: 'ean13',
      title: 'EAN13',
      sortable: false
    },
    {
      field: 'productOriginId',
      title: 'Marca',
      sortable: false,
      formater: (value: unknown) =>
        productOrigins?.find((el) => el.productOriginId === (value as number))
          ?.name || ''
    },
    {
      field: 'active',
      title: 'Activo',
      sortable: false,
      formater: (value: unknown) => <YesNoBadge value={value as boolean} />
    },
    {
      field: 'batch',
      title: 'Lote',
      sortable: false,
      formater: (value: unknown) => <YesNoBadge value={Boolean(value)} />
    },
    {
      field: 'expirationDate',
      title: 'Fecha Vencimiento',
      sortable: false,
      formater: (value: unknown) => <YesNoBadge value={Boolean(value)} />
    },
    {
      field: 'isGreenSale',
      title: 'Venta en Verde',
      sortable: false,
      formater: (value: unknown) => <YesNoBadge value={Boolean(value)} />
    }
  ]

  return tableHeadersProduct
}

const setImage = (pImage: ProductImage[] | unknown) => {
  const imageAux = pImage as ProductImage[]

  const image =
    imageAux && imageAux.length > 0
      ? imageAux[0].url
      : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

  return (
    <Avatar
      style={{ height: '65px', width: '65px' }}
      variant='square'
      alt='SkuImage'
      src={image}
    />
  )
}
